import { SetMemberRoleDocument } from "@pathwright/graphql-client/src/generated"

export default SetMemberRoleDocument
